import { ActionsUnion, createAction } from "../../../redux/ActionHelper";
import { PageFeature, Themes } from "../../../../common/Constants";
import { IMessages, IModals, IPanels, IViewOptions } from "../Contracts";

/**
 * Actions for Page view
 */
export enum PageActionTypes {
    InitPage = "Page/InitPage",

    LogTelemetry = "Page/LogTelemetry",

    SetTheme = "Page/SetTheme",
    UpdatePanels = "Page/UpdatePanels",
    UpdateModals = "Page/updateModals",
    UpdateMessages = "Page/updateMessages"
}

const PageStandardActions = {
    initPage: () => createAction(PageActionTypes.InitPage),
    logTelemetry: (feature: PageFeature, action: string, properties?: { [key: string]: any }, errorMessage?: string) =>
        createAction(PageActionTypes.LogTelemetry, { feature, action, properties, errorMessage }),

    setTheme: (theme: Themes) => createAction(PageActionTypes.SetTheme, theme),
    updatePanels: (panels: IPanels) => createAction(PageActionTypes.UpdatePanels, panels),
    updateModals: (modals: IModals) => createAction(PageActionTypes.UpdateModals, modals),
    updateMessages: (messages: IMessages) => createAction(PageActionTypes.UpdateMessages, messages)
};

const PageThunkActions = {

}

const PageThunkActionsTypes = {

}

export const PageActions = {...PageStandardActions, ...PageThunkActions};
const AllActionsTypes = {...PageStandardActions, ...PageThunkActionsTypes};
export type PageActionsType = ActionsUnion<typeof AllActionsTypes>;
